import { render, staticRenderFns } from "./CeHua.vue?vue&type=template&id=37de4402&scoped=true&"
import script from "./CeHua.vue?vue&type=script&lang=js&"
export * from "./CeHua.vue?vue&type=script&lang=js&"
import style0 from "./CeHua.vue?vue&type=style&index=0&id=37de4402&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37de4402",
  null
  
)

export default component.exports